import { useTranslation } from 'react-i18next';
import JobsTab from '@/components/recruiter/tabs/JobsTab';

export default function JobsPage() {
  const { t } = useTranslation('jobOffers');

  return (
    <div className="container-custom py-8">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">
          {t('manager.tabs.jobs', 'Jobs')}
        </h1>
        <p className="text-gray-600">{t('jobs.list.subtitle', 'Manage your job listings')}</p>
      </div>
      <JobsTab />
    </div>
  );
}
